// Every gradient/tint is mixed from the six brand bar colours, keyed by colour.
export const GRAD = {
    '#FFCE00': 'linear-gradient(135deg,#FFCE00,#F0A500)',
    '#E4003C': 'linear-gradient(135deg,#FF3B5C,#E4003C)',
    '#0B72C9': 'linear-gradient(135deg,#2E9BE0,#0B72C9)',
    '#2E9B3F': 'linear-gradient(135deg,#3FBF54,#2E9B3F)',
    '#96298E': 'linear-gradient(135deg,#B23DAA,#96298E)',
    '#F47B20': 'linear-gradient(135deg,#FF9A3D,#F47B20)'
};

export const TINT = {
    '#FFCE00': 'rgba(255,206,0,0.18)',
    '#E4003C': 'rgba(228,0,60,0.12)',
    '#0B72C9': 'rgba(11,114,201,0.12)',
    '#2E9B3F': 'rgba(46,155,63,0.14)',
    '#96298E': 'rgba(150,41,142,0.12)',
    '#F47B20': 'rgba(244,123,32,0.14)'
};

export const SHADOW = {
    '#FFCE00': 'rgba(240,165,0,0.7)',
    '#E4003C': 'rgba(228,0,60,0.7)',
    '#0B72C9': 'rgba(11,114,201,0.7)',
    '#2E9B3F': 'rgba(46,155,63,0.7)',
    '#96298E': 'rgba(150,41,142,0.7)',
    '#F47B20': 'rgba(244,123,32,0.7)'
};

// Yellow is never used as text on a light background; this ochre stands in for it.
const ON_YELLOW = '#6b5200';
export const onLight = (color) => color === '#FFCE00' ? ON_YELLOW : color;
export const inkOn = (color) => color === '#FFCE00' ? ON_YELLOW : '#fff';

// Cards in a row reveal a beat apart, capped so the last card never waits long.
export const stagger = (index, step = 90) => Math.min(index * step, 360) + 'ms';

// Keeps Nordic names (Ålshult, Ulvö) readable when used as ids.
export const slug = (value) => value.normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().replace(/ø/g, 'o').replace(/æ/g, 'ae')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

// Files in public/assets, resolved against the app's base path.
export const asset = (path) => `${process.env.PUBLIC_URL}/${path}`;

// A full URL (an upload served by the API) as is, anything else as a file in public/assets.
export const mediaUrl = (src) => /^https?:\/\//.test(src) ? src : asset(src);

export const prefersReducedMotion = () =>
    !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

class Utils {
    static getErrorMessage(err) {
        let error = "Oops...something went wrong.";
        if (err.response && err.response.data) {
            if (err.response.data.message) {
                error = err.response.data.message;
            }
        } else if (err.message) {
            error = err.message;
        }
        return error;
    }
}

export default Utils;
